import { ActionReducerMap, combineReducers, createFeature, createFeatureSelector } from '@ngrx/store';
import { ContentListSearchState, ContentListState, CurrentContentState } from './content.entity';
import { contentsList, contentsSearchList, currentContent } from './content.reducer';

export const CONTENT_FEATURE_NAME: string = 'contents';

// Selector for top-level content
export const selectContentState = createFeatureSelector<ContentState>(CONTENT_FEATURE_NAME);

export interface ContentState {
	contentsList: ContentListState;
	contentsSearchList: ContentListSearchState;
	currentContent: CurrentContentState;
}

export const reducers = combineReducers({
	contentsList: contentsList,
	contentsSearchList: contentsSearchList,
	currentContent: currentContent
});

export const contentFeature = createFeature({
name: CONTENT_FEATURE_NAME,
reducer: reducers

});